// @ts-nocheck
import React, { useState } from 'react';
import { useAction } from 'wasp/client/operations';
import { createTierCheckout } from 'wasp/client/operations';
// AppFrame removed here: page is wrapped at route level
import { Button } from '../components/ui/button';
import { Card, CardContent, CardHeader, CardTitle } from '../components/ui/card';
import { Badge } from '../components/ui/badge';
import { Check } from 'lucide-react';
import { Switch } from '../components/ui/switch';
import { DISPLAY_NAME, MAX_HOUSEHOLD_BY_TIER } from '../../billing/tiers';

// Tier data with features and annual savings
const tiers = [
  {
    internalName: 'demo' as const,
    monthlyPrice: 0,
    annualPrice: 0,
    features: [
      `Plans for up to ${MAX_HOUSEHOLD_BY_TIER.demo} people`,
      'Preview weekly plans',
      'No card required',
      'Basic grocery lists',
    ],
    savings: 0,
  },
  {
    internalName: 'starter' as const,
    monthlyPrice: 19.99,
    annualPrice: 199.99,
    features: [
      `Unlimited plans for up to ${MAX_HOUSEHOLD_BY_TIER.starter} people`,
      'Smart grocery lists',
      'Recipe saving & collections',
      'Equipment-based adjustments',
    ],
    savings: 'Save 15% annually',
  },
  {
    internalName: 'core_plus' as const,
    monthlyPrice: 29.99,
    annualPrice: 299.99,
    features: [
      `Scaling up to ${MAX_HOUSEHOLD_BY_TIER.core_plus} people`,
      'AI recipe personalization',
      'Batch prep automation',
      'Unlimited swaps & plans',
    ],
    savings: 'Save 15% annually',
  },
];

const testimonials = [
  {
    name: "Sarah Mitchell",
    role: "Busy Mom of 3",
    content: "This app has transformed our family dinners. The AI suggestions actually understand our kids' preferences!",
    rating: 5
  },
  {
    name: "David Chen",
    role: "Fitness Enthusiast", 
    content: "The nutritional tracking and macro-friendly recipes have helped me stay on track with my goals.",
    rating: 5
  },
  {
    name: "Maria Rodriguez",
    role: "Working Professional",
    content: "Meal planning used to take hours. Now I have a week's worth of meals planned in 10 minutes.",
    rating: 5
  }
];

export function PricingPage() {
  const [billingCycle, setBillingCycle] = useState<'monthly' | 'annual'>('monthly');
  const doCreateTierCheckout = useAction(createTierCheckout);
  
  const currentPrice = billingCycle === 'annual' ? 'annualPrice' : 'monthlyPrice';

  const handleUpgrade = async (tier: 'demo' | 'starter' | 'core_plus') => {
    try {
      const result = await doCreateTierCheckout({ tier, billingCycle });
      if (result.success) {
        window.location.href = result.checkoutUrl;
      }
    } catch (error) {
      console.error('Upgrade failed:', error);
    }
  };

  return (
      <div className="space-y-8">
        <h1 className="text-3xl font-bold text-center">Choose Your Plan</h1>

        {/* Billing Cycle Toggle */}
        <div className="flex justify-center items-center gap-4">
          <span className="text-sm font-medium">Monthly</span>
          <Switch
            checked={billingCycle === 'annual'}
            onCheckedChange={(checked) => setBillingCycle(checked ? 'annual' : 'monthly')}
          />
          <span className="text-sm font-medium">Annual (20% savings)</span>
        </div>

        <div className="grid md:grid-cols-3 gap-8 max-w-6xl mx-auto">
          {tiers.map((tier) => {
            const displayName = DISPLAY_NAME[tier.internalName];
            const priceValue = tier[currentPrice as keyof typeof tier] as number;
            const formattedPrice = priceValue === 0 ? 'Free' : `$${priceValue.toFixed(2)}`;
            const isDemo = tier.internalName === 'demo';

            return (
            <Card key={tier.internalName} className="border-2 border-gray-200 rounded-lg p-6">
              <CardHeader>
                <CardTitle className="text-2xl">{displayName}</CardTitle>
                <p className="text-3xl font-bold">
                  {formattedPrice}
                  {!isDemo && `/${billingCycle === 'annual' ? 'year' : 'month'}`}
                </p>
                {tier.savings && <Badge variant="secondary">{tier.savings}</Badge>}
              </CardHeader>
              <CardContent className="space-y-4">
                {tier.features.map((feature, index) => (
                  <div key={index} className="flex items-center gap-2">
                    <Check className="h-4 w-4 text-green-500" />
                    <span>{feature}</span>
                  </div>
                ))}
                <Button
                  onClick={() => handleUpgrade(tier.internalName)}
                  className="w-full mt-4"
                  variant={isDemo ? 'outline' : 'default'}
                  disabled={isDemo}
                >
                  {isDemo ? 'Current Plan' : `Get ${displayName}`}
                </Button>
              </CardContent>
            </Card>
          )})}
        </div>
      </div>
  );
}
// @ts-nocheck
